<template>
  <el-card>
    <section>
      <!--列表-->
      <template>
        <el-table border :data="newsList" highlight-current-row v-loading="loading" style="width: 100%;">
          <el-table-column type="index" width="60">
          </el-table-column>
          <el-table-column prop="name" label="指标" sortable>
          </el-table-column>
          <el-table-column prop="value1" label="配置(%)" sortable>
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button class="btn-text-pd0" size="mini" type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!--工具条-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="padding: 15px 5px">
      </el-pagination>

      <el-dialog :title="title" :visible.sync="formVisible" :close-on-click-modal="false">
        <el-form :model="form" :rules="formRules" label-width="180px" ref="form" >
          <div style="padding-top: 10px">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="指标" prop="title">
                  <el-input disabled v-model="form.name" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="配置(%)" prop="value1">
                  <el-input type="number" v-model="form.value1" auto-complete="off" placeholder="请输入百分比" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click.native="formVisible = false">取消</el-button>
          <el-button size="medium" type="primary" @click.native="formSubmit" :loading="formLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>
  </el-card>
</template>
<script>
/* eslint-disable */
import { doPost } from '../../api/api'
export default {
  data () {
    return {
      filters: {
      },
      loading: false,
      newsList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      form:{
        id:'',
        name: 1,             //所属类型
        value1: 1,           //首次天数
        value2: '',          //二次天数
      },
      formVisible: false,
      title: '',
      formRules: {
        value1: [
          { pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/, message: '格式错误，请输入正数数字!', trigger: 'change' },
        ]
      },
      formLoading: false,
      user:{},
    }
  },
  methods: {
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.getPgaeList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getPgaeList()
    },
    // 获取列表（查询条件，欠缺调整）
    getPgaeList: function () {
      this.loading = true
      let para = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        dictType: 'target_data'
      }
      doPost('/sysDict/getPageList', para).then(res => {
        this.newsList = res.result.list
        this.total = res.result.total
      })
      this.loading = false
    },
    //编辑
    handleEdit:function (id) {
      this.title = '编辑'
      this.formVisible = true
      let para = {
        id: id
      }
      doPost('/sysDict/getById',para).then(res =>{
        this.form = res.result
        delete this.form.updateDate
        delete this.form.createDate
        console.log(this.form)
      })
    },
    //提交
    formSubmit:function () {
      delete this.form.uploadStr
      if(this.form.value1 == null || this.form.value1 == ''){
        this.$message.error('配置不可为空！')
        return
      }
      console.log(this.form)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗', '提示', {
            confirmButtonText: '继续提交',
            cancelButtonText: '取消'
          }).then(() => {
            this.formLoading = true
            let para = Object.assign({}, this.form)
            doPost('/sysDict/update', para).then((res) => {
              this.formLoading = false
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.$refs['form'].resetFields()
              this.formVisible = false
              this.getPgaeList()
            })
          })
        }
      })
    }
  },
  mounted () {
    var user = JSON.parse(sessionStorage.getItem('user'))
    console.log(user)
    this.getPgaeList()
  }
}

</script>

<style scoped>

</style>
